// Bells Test (Rousseaux) — norms cutoffs for pathological vs. normal performance.
// Pathological if ANY of:
//   - Total omissions > age cutoff (Niv 1 uses fixed cutoff of 7)
//   - |omG - omD| > 2 (or > 3 for Niv 1)
//   - >= 1 selection error
//   - Time > age cutoff
const TOTAL_BELLS = 35;

export const getBellsOmissionsCutoff = (age, niveau) => {
  if (niveau === "I") return 7;
  if (age == null) return null;
  if (age <= 34) return 5;
  if (age <= 49) return 6;
  return 7;
};

export const getBellsDiffCutoff = (niveau) => (niveau === "I" ? 3 : 2);

export const getBellsTempsCutoff = (age) => {
  if (age == null) return null;
  if (age <= 34) return 142;
  if (age <= 49) return 145;
  if (age <= 64) return 184;
  return 253;
};

const toInt = (v) => {
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
};
const toFloat = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
};

export const calcBellsRousseaux = ({ age, niveau, omG, omD, erreurs, temps }) => {
  const omGNum = toInt(omG);
  const omDNum = toInt(omD);
  const errNum = toInt(erreurs);
  const tempsNum = toFloat(temps);

  const haveOm = omGNum != null && omDNum != null;
  const omTotal = haveOm ? omGNum + omDNum : null;
  const cibles = haveOm ? TOTAL_BELLS - omTotal : null;
  const diff = haveOm ? Math.abs(omGNum - omDNum) : null;

  const omCutoff = getBellsOmissionsCutoff(age, niveau);
  const diffCutoff = getBellsDiffCutoff(niveau);
  const tempsCutoff = getBellsTempsCutoff(age);

  const omPath = omCutoff != null && omTotal != null && omTotal > omCutoff;
  const diffPath = diff != null && diff > diffCutoff;
  const errPath = errNum != null && errNum >= 1;
  const tempsPath = tempsCutoff != null && tempsNum != null && tempsNum > tempsCutoff;

  const pathological = omPath || diffPath || errPath || tempsPath;

  return {
    omG: omGNum,
    omD: omDNum,
    omTotal,
    cibles,
    diff,
    erreurs: errNum,
    temps: tempsNum,
    cutoffs: { omissions: omCutoff, diff: diffCutoff, temps: tempsCutoff },
    pathological,
    flags: { omPath, diffPath, errPath, tempsPath },
  };
};
